import {sendDesktopAnalyticsEvent} from '@optimaxdev/analytics/desktop/lib/sendAnalyticsEvent/index';
import {pushSnackInfo} from '@optimaxdev/design-system';

import {CART_UPGRADE_CLOSE_ACCESSORY_NOTIFICATION} from 'constants/analytics/events/cartUpgrade';

type NotificationCartType = 'Added' | 'Removed';

export function handlePushToSnackBar(notificationType: 'Removed', accessoryName: string): void;
export function handlePushToSnackBar(notificationType: 'Added'): void;
/**
 * Add new notification in SnackBar
 * @param {NotificationCartType} notificationType - type of notification
 */
export function handlePushToSnackBar(
    notificationType: NotificationCartType,
    accessoryName?: string,
) {
    let SNACKBAR_TEXT_MESSAGE: string =
        notificationType === 'Added' ? 'Item added to your cart' : 'Item removed from your cart';
    if (notificationType === 'Removed')
        SNACKBAR_TEXT_MESSAGE = `${accessoryName} was removed from your shopping cart.`;

    pushSnackInfo(null, SNACKBAR_TEXT_MESSAGE, {
        hasAutoClose: true,
        iconType: 'success',
        onClose: () => {
            sendDesktopAnalyticsEvent(CART_UPGRADE_CLOSE_ACCESSORY_NOTIFICATION, {
                notificationType,
            });
        },
        variant: 'notification',
    });
}
